import Actions from "../actions";
import { produce } from "immer";

const initialState = {
    customers: {},
    selectedCustomerId:"",
    selectedCustomerIdForAppointmentViewDetails:""
};


const customers = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.GET_CUSTOMERS_LIST: {
      draft.customers = payload?.customers;
      break;
    }

    case Actions.SELECTED_CUSTOMER_ID: {
      draft.selectedCustomerId = payload?.selectedCustomerId;
      break;
    }

    case Actions.SELECTED_CUSTOMER_ID_FOR_APPOINTMENT_VIEW_DETAILS: {
      draft.selectedCustomerIdForAppointmentViewDetails = payload?.selectedCustomerIdForAppointmentViewDetails;
      break;
    }



    default: {
      break;
    }
  }
}, initialState);

export default customers;
